import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getRoot, HISTORY_MERGE_TAG, type EditorState } from 'lexical';
import { FC, useEffect } from 'react';

import { $readTemplateSection } from '../../../lib';
import { $isTemplateHeadingNode } from '../nodes';

const readSectionIds = (state: EditorState) =>
  state.read(() =>
    $getRoot()
      .getChildren()
      .filter($isTemplateHeadingNode)
      .map((heading) => $readTemplateSection(heading)?.ID ?? '')
      .join('\n'),
  );

// Before a recording only the fields' titles and instructions are typed: an
// edit that adds, removes or moves a field is taken back at once.
export const TemplateStructureLockPlugin: FC = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(
    () =>
      editor.registerUpdateListener(
        ({ editorState, prevEditorState, dirtyElements }) => {
          if (
            dirtyElements.size &&
            readSectionIds(editorState) !== readSectionIds(prevEditorState)
          ) {
            editor.setEditorState(prevEditorState, { tag: HISTORY_MERGE_TAG });
          }
        },
      ),
    [editor],
  );

  return null;
};
